import Typography from "@bmi-digital/components/typography";
import { styled } from "@mui/material/styles";

export const BodyTitle = styled(Typography)({
  marginBottom: "20px"
});

export const FooterTitle = styled(Typography)({
  marginBottom: "20px"
});
